import { render, staticRenderFns } from "./Oneclick.vue?vue&type=template&id=2a16efe6&scoped=true&"
import script from "./Oneclick.vue?vue&type=script&lang=js&"
export * from "./Oneclick.vue?vue&type=script&lang=js&"
import style0 from "./Oneclick.vue?vue&type=style&index=0&id=2a16efe6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16efe6",
  null
  
)

export default component.exports